import { COLOR, FONT_SIZE, FONT_WEIGHT, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

const BUTTON_MAX_WIDTH = 240;

export const ButtonActionWrapper = styled.button`
  padding: 12px 16px;
  border: 1px solid ${COLOR.YELLOW900.code};
  border-radius: 8px;
  background-color: ${COLOR.GRAY200.code};
`;

export const GridContainer = styled.div`
  display: grid;
  place-content: center;
  place-items: center;
  align-content: stretch;
  grid-template-columns: 1fr minmax(auto, ${BUTTON_MAX_WIDTH}px);
  column-gap: 8px;
  ${mq.sp} {
    grid-template-columns: 1fr;
  }
`;

export const DivSummaryWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`;

export const ParSummary = styled.span`
  text-align: center;
  font-weight: ${FONT_WEIGHT.BOLD};
  font-size: ${FONT_SIZE.M + 2}px;
  color: ${COLOR.YELLOW900.code};
  white-space: nowrap;
`;

export const ParSubSummary = styled.p`
  text-align: center;
  font-weight: ${FONT_WEIGHT.NORMAL};
  font-size: ${FONT_SIZE.S}px;
  color: ${COLOR.GRAY900.code};
`;

export const AnchorPurchase = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: ${BUTTON_MAX_WIDTH}px;
  height: 48px;
  border-radius: 50px;
  background-color: ${COLOR.YELLOW50.code};
  color: ${COLOR.GRAY50.code};
  font-weight: ${FONT_WEIGHT.BOLD};
  padding: 0 16px;
  white-space: nowrap;

  ${mq.sp} {
    margin-top: 8px;
    height: 40px;
  }
`;
